import { OrdersTable } from '@/components/features/orders/OrdersTable'

export const Orders = () => {
  return <OrdersTable />
}

/** Point of sale → Orders: the same list, on the till channel. */
export const PosOrders = () => <OrdersTable channel="pos" />
